// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const applyCookiePromo = (): ((
  apiInstance: AxiosInstance
) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.post(`/v5/promotions/redeem`);
};

export default applyCookiePromo;
